import {
  createMaterialTopTabNavigator,
  MaterialTopTabNavigationEventMap,
  MaterialTopTabNavigationOptions
} from "expo-router/js-top-tabs";
import { TabNavigationState } from "expo-router/react-navigation";
import { useGlobalSearchParams, useLocalSearchParams, useNavigation, withLayoutContext } from 'expo-router';
import { useEffect, useLayoutEffect, useState } from 'react';
import { StyleSheet, useWindowDimensions, View } from 'react-native';
import Animated, { FadeInDown, FadeOutDown } from 'react-native-reanimated';

import ImpactMapPill from '@/components/impact/ImpactMapPill';
import { underlineTopTabOptions } from '@/constants/layout';
import { ParamListBase } from '@/types/navigation';
import { i18n } from '@/utils/i18n';
import Title from '@/components/Title';
import GoBackButton from '@/components/buttons/GoBackButton';

const { Navigator } = createMaterialTopTabNavigator();
export const MaterialTopTabs = withLayoutContext<
  MaterialTopTabNavigationOptions,
  typeof Navigator,
  TabNavigationState<ParamListBase>,
  MaterialTopTabNavigationEventMap
>(Navigator);

const ImpactPeriodLayout = () => {
  const navigation = useNavigation();
  const { npoType } = useLocalSearchParams<{ npoType: 'charity' | 'church' }>();
  const { showMapPill } = useGlobalSearchParams<{ showMapPill: 'true' | 'false' }>();

  const { width } = useWindowDimensions();

  const [showMapState, setShowMapState] = useState<boolean>(true);

  useEffect(() => {
    setShowMapState(showMapPill === 'true' || showMapPill === undefined);
  }, [showMapPill]);

  //Locales
  const month = i18n.t('mix.month');
  const year = i18n.t('mix.year');
  const all_time = i18n.t('mix.all_time');
  const charities_title = i18n.t('home.charities');
  const churches_title = i18n.t('home.churches');

  const titleScreen = npoType !== undefined ? (npoType === 'charity' ? charities_title : churches_title) : '';

  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: true,
      headerShadowVisible: false,
      headerBackVisible: false,
      headerTitle: () => <Title label={titleScreen} />,
      headerLeft: () => <GoBackButton />
    });
  }, [npoType]);

  return (
    <View style={style.mainContainer}>
      <MaterialTopTabs screenOptions={underlineTopTabOptions({ width: width, tabQty: 3 })}>
        <MaterialTopTabs.Screen
          name="monthImpact"
          options={{ title: month, tabBarPressColor: 'transparent' }}
          initialParams={{
            npoType: npoType
          }}
        />
        <MaterialTopTabs.Screen
          name="yearImpact"
          options={{ title: year, tabBarPressColor: 'transparent' }}
          initialParams={{
            npoType: npoType
          }}
        />
        <MaterialTopTabs.Screen
          name="allTimeImpact"
          options={{ title: all_time, tabBarPressColor: 'transparent' }}
          initialParams={{
            npoType: npoType
          }}
        />
      </MaterialTopTabs>
      {showMapState && (
        <Animated.View style={{ zIndex: 999 }} entering={FadeInDown} exiting={FadeOutDown}>
          <ImpactMapPill npoType={npoType} />
        </Animated.View>
      )}
    </View>
  );
};

export default ImpactPeriodLayout;

const style = StyleSheet.create({
  mainContainer: {
    flex: 1
  },

  filterButton: {
    position: 'absolute',
    top: 15,
    right: 18
  },

  filterIcon: {
    height: 20,
    width: 20
  },

  backBtn: {
    marginLeft: 18
  }
});
